import { render, staticRenderFns } from "./updateDeduct.vue?vue&type=template&id=38fad807&scoped=true&"
import script from "./updateDeduct.vue?vue&type=script&lang=js&"
export * from "./updateDeduct.vue?vue&type=script&lang=js&"
import style0 from "./updateDeduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./updateDeduct.vue?vue&type=style&index=1&id=38fad807&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fad807",
  null
  
)

export default component.exports